@if (forelder().harForelder) {
  @switch (stil()) {
    @case ('kort') {
      <a (click)="gaaTilForelder()"
         class="med-gruppefarge wk-forelder std-font gruppe-fargeindikator-border_left e2e-forelder"
         [style.border-left-color]="gruppefarge().rammeFarge"
         [matTooltip]="fullStiSomRenTekst()">
        <ng-content/>
        <span [innerHTML]="forelder().beskrivelse | strengMal"></span>
        <mat-icon inline="true" class="navigasjon">arrow_right_alt</mat-icon>
      </a>

    }
    @default {
      <span class="ledetekst">
        <ng-content/>
      </span>
      <span (click)="gaaTilForelder()" [innerHTML]="forelder().beskrivelse | strengMal:'lang'" class="sti" [matTooltip]="fullStiSomRenTekst()"></span>
    }
  }

<!--  <span  >
    <span  [innerHTML]="forelder().beskrivelse | strengMal:'lang'"  ></span>
    ##
    {{fullStiSomRenTekst()}}
  </span>-->
}

